import * as Components from "./FocusLayout";
import { Body } from "./FocusLayout.styled";

const FocusLayout = {
  ...Components,
  Body,
};

export { FocusLayout };
